import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay, Select, SimpleGrid, Stack, Text
} from "@chakra-ui/react";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { ModeloItemOrcamento } from "models/modelo_item_orcamento";
import { OrderCategory } from "models/order_category";
import { OrderItemProduct } from "models/order_item_product";
import { useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { MdDelete, MdEdit } from "react-icons/md";
import ItemProdutoTable from "./ItemTable";
import OrderItemDynamicTable from "./OrderItemDynamicTable";

interface IOrderItemDynamic {
  textColor: string;
  brandStars: string;
  borderColor: string;
  itens: OrderCategory[] | undefined;
  showCategory: boolean;
  nomeRef: any;
  saveItem: () => void;
  changeItem: (item: OrderCategory) => void;
  removeItem: (item: OrderCategory) => void;
  showItemModal: (show: boolean) => void;
  reorder: (
    list: OrderCategory[],
    startIndex: number,
    endIndex: number
  ) => void;
  drag: boolean;
  isDragable: (drag: boolean) => void;
  onChangeTemplate: (item : string) => void;
  templateList : ModeloItemOrcamento[];
  totalOrder: number;
  condicaoPagamento: CondicaoPagamento[] | undefined;
  addRowItem: (item: OrderItemProduct, categ: OrderCategory) => void;
  editRow: (item: OrderItemProduct, categ: OrderCategory) => void;
  deleteRow: (item: OrderItemProduct, categ: OrderCategory) => void;
  itemList: OrderItemProduct[];
}

const OrderItemDynamic = ({
  textColor,
  brandStars,
  borderColor,
  itens,
  showCategory,
  nomeRef,
  saveItem,
  changeItem,
  removeItem,
  showItemModal,
  reorder,
  drag,
  isDragable,
  onChangeTemplate,
  templateList,
  totalOrder,
  condicaoPagamento,
  addRowItem,
  deleteRow,
  editRow,
  itemList
}: IOrderItemDynamic) => {

  const [isEdit, setIsEdit] =  useState(false);
  const [selectedItem, setSelectedItem] = useState<OrderCategory>();


  const onDragEnd = (result: any) => {
    reorder(itens, result.source.index, result.destination.index);
  };

  const formatNumber = (q: any) => {
    return q.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'

    })
   } 

   const editItem = (item: OrderCategory) => {
     setIsEdit(true);
     nomeRef.current = item.descricao;
     showItemModal(true);
     setSelectedItem(item);
   }

   const saveEdit = () => {
    selectedItem.descricao = nomeRef.current;
    setIsEdit(false);
    nomeRef.current= "";
    changeItem(selectedItem);
    setSelectedItem(null);
    showItemModal(false);
   }
   useEffect(() => {}, [totalOrder]);
  return (
    <AccordionItem>
      <h2>
        <AccordionButton>
          <Box flex="1" textAlign="left" color={"#422AFB"} fontWeight={"bold"}>
            Itens do Orçamento
          </Box>
          <AccordionIcon color={"#422AFB"} />
        </AccordionButton>
      </h2>

      <AccordionPanel pb={4} minHeight={1000}>

      
        <Stack>
          <Button
            marginTop={0}
            mb={8}
            variant={"outline"}
            onClick={() => {
              showItemModal(true);
            }}
            alignSelf={"flex-end"}
            colorScheme="brand"
            isLoading={false}
          >
            Adicionar Novo Grupo
          </Button>
        </Stack>

        <SimpleGrid columns={4} mb={16} mt={-16}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            mt={4}
            color={textColor}
          >
            Templates de Itens
          </FormLabel>
            <Select onChange={(e) => onChangeTemplate(e.target.value)}>
              <option value='0'>Selecione um template de Itens</option>
                {
                  templateList?.map((note) => (
                    <option value={note.id}>{note.nome}</option>
                  ))
                }

              </Select>
          </FormControl>
        
        </SimpleGrid> 


        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {provided.placeholder}
                {itens?.map((item, index) => {
                  return (
                    <Draggable
                      key={`${item.id}`}
                      draggableId={`${item.id}-${item.descricao}-${index}`}
                      index={index}
                      isDragDisabled={drag}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <Box key={`${item.id}-${index}`} mb={16}>
                            <Box flex="1" flexDirection={"row"}>
                              <Text
                                textAlign="left"
                                color={"#422AFB"}
                                fontWeight={"bold"}
                                fontSize={28}
                              >
                                {index + 1} - {item.descricao} - subtotal : {' '}
                                {formatNumber(Number(item.valor))}
                              </Text>
  

                              <Button
                                leftIcon={<MdDelete />}
                                colorScheme="red"
                                variant="solid"
                                float={"right"}
                                mt={-12}
                                onClick={() => removeItem(item)}
                              >
                                Excluir
                              </Button>
                              <Button
                                  leftIcon={<MdEdit/>}
                                  colorScheme="green"
                                  variant="solid"
                                  float={"right"}
                                  mt={-12}
                                  mr={128}
                                  onClick={() => {editItem(item)}}
                                >
                                Editar
                                </Button>
                            </Box>


                            <Text
                              textAlign="left"
                              color={"#422AFB"}
                              fontWeight={"bold"}
                              mt={20}
                              fontSize={20}
                            >
                              SERVIÇOS
                            </Text>

                            <OrderItemDynamicTable
                              key={`${item.id}-${item.descricao}-${index}-table`}
                              borderColor={borderColor}
                              index={index}
                              item={item}
                              changeItem1={changeItem}
                              isDragable={isDragable}
                              condicaoPagamento={condicaoPagamento}
                            />

<Text
                            textAlign="left"
                            color={"#422AFB"}
                            fontWeight={"bold"}
                            mt={20}
                            fontSize={20}
                          >
                            PRODUTOS
                          </Text>
                          <ItemProdutoTable
                            addRowItem={addRowItem}
                            borderColor={borderColor}
                            deleteRow={deleteRow}
                            editRow={editRow}
                            itemList={itemList}
                            categ={item}
                          
                          />
                          </Box>
                        </div>
                      )}
                    </Draggable>
                  );
                })}
              </div>
            )}
          </Droppable>
        </DragDropContext>

        <Modal
          onClose={() => {
            showItemModal(false);
          }}
          size={"2xl"}
          isOpen={showCategory}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{isEdit ? 'Editar Grupo' : 'Novo Grupo'}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <FormControl>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  color={textColor}
                  mb="8px"
                >
                  Nome<Text color={brandStars}>*</Text>
                </FormLabel>
                <Input
                  ref={nomeRef}
                  defaultValue={nomeRef.current}
                  isRequired={true}
                  variant="auth"
                  fontSize="sm"
                  ms={{ base: "0px", md: "0px" }}
                  type="text"
                  placeholder="Preencha o nome do Grupo"
                  onChange={(e) => (nomeRef.current = e.target.value)}
                  mb="24px"
                  fontWeight="500"
                  size="lg"
                />
              </FormControl>
            </ModalBody>
            <ModalFooter>
              <Button
                onClick={() => {
                  showItemModal(false);
                }}
                variant="outline"
                marginRight={4}
              >
                Fechar
              </Button>
              <Button
                onClick={() => {
                  isEdit ? saveEdit() : saveItem();
                }}
                colorScheme="brand"
              >
                Salvar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </AccordionPanel>
    </AccordionItem>
  );
};
export default OrderItemDynamic;
